<form [formGroup]="recurringDepositProductDetailsForm">
  <div fxLayout="row wrap" fxLayoutGap="2%" fxLayout.lt-md="column">
    <mat-form-field fxFlex="48%">
      <mat-label>{{ 'labels.inputs.Product Name' | translate }} </mat-label>
      <input
        matInput
        formControlName="name"
        matTooltip="{{ 'tooltips.Product name is a unique identifier' | translate }}"
        required
      />
      <mat-error *ngIf="recurringDepositProductDetailsForm.controls.name.hasError('required')">
        {{ 'labels.inputs.Product Name' | translate }} {{ 'labels.commons.is' | translate }}
        <strong>{{ 'labels.commons.required' | translate }}</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field fxFlex="48%">
      <mat-label>{{ 'labels.inputs.Short Name' | translate }}</mat-label>
      <input
        matInput
        formControlName="shortName"
        maxlength="4"
        matTooltip="{{ 'tooltips.Short name is a unique identifier' | translate }}"
        required
      />
      <mat-error *ngIf="recurringDepositProductDetailsForm.controls.shortName.hasError('required')">
        {{ 'labels.inputs.Short Name' | translate }} {{ 'labels.commons.is' | translate }}
        <strong>{{ 'labels.commons.required' | translate }}</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field fxFlex="98%">
      <mat-label>{{ 'labels.inputs.Description' | translate }}</mat-label>
      <textarea
        matInput
        formControlName="description"
        matTooltip="{{
          'tooltips.Description is used to provide additional information regarding the purpose' | translate
        }}"
        cdkTextareaAutosize
        cdkAutosizeMinRows="2"
      ></textarea>
      <mat-error *ngIf="recurringDepositProductDetailsForm.controls.description.hasError('required')">
        {{ 'labels.inputs.Description' | translate }} {{ 'labels.commons.is' | translate }}
        <strong>{{ 'labels.commons.required' | translate }}</strong>
      </mat-error>
    </mat-form-field>
  </div>

  <div fxLayout="row" class="margin-t" fxLayout.xs="column" fxLayoutAlign="center" fxLayoutGap="2%">
    <button mat-raised-button matStepperPrevious disabled>
      <fa-icon icon="arrow-left" class="m-r-10"></fa-icon>
      {{ 'labels.buttons.Previous' | translate }}
    </button>
    <button mat-raised-button matStepperNext>
      {{ 'labels.buttons.Next' | translate }}
      <fa-icon icon="arrow-right" class="m-l-10"></fa-icon>
    </button>
  </div>
</form>
